<template>

<div>
  <div id="dummyFileURL" style="display:none"> 
    
    <img src="@/assets/dummy/dummy.png"/>
  </div>
  <b-modal
    centered
    :title="$t('title')"
    modal-class="bd-modal"
    v-model="localValue"
    size="lg"
    ref="modal"
    id="add-certification-modal"
  >
    <div>
      <div>
          <div v-if="view==1">
            <div>
              <div style="color:red">{{$t('hkpost_remark')}}</div>
              <u><a style="color:blue" href="https://www.hongkongpost.gov.hk/product/ecert/status/index.html" taget="_blank">https://www.hongkongpost.gov.hk/product/ecert/status/index.html</a></u>
            </div>
            <!--<div v-if="!isForProfessional">
              {{$t('hkid')}}
            </div>
            
            <div  v-if="!isForProfessional" style="margin-top:10px">
                <b-form-input  v-model="hkid" />
            </div>-->
            <div  style="margin-top:10px">
              {{$t('upload')}}
            </div>
        
            <div class="upload-file" style="margin-top:10px">
                <b-form-file class="upload-file__form"
                  v-model="file"
                  :placeholder="$t('placeholder')"
                  accept=".crt,.cer"
                  :drop-placeholder="$t('dropplaceholder')" />
            </div>
            
          </div>
          <div v-if="view==2">
            
          </div>
          <!-- <div style="margin-top:10px"></div>
           <b-button class="bd-button" @click="uploadCert()">
            {{$t('confirm')}}
          </b-button>
          <b-button class="bd-button ml-2" @click="closeModal('add-certification-modal')">
            {{$t('close')}}
          </b-button> -->
      </div>
    </div>
    <template #modal-footer>
      <b-button class="bd-button" @click="uploadCert()">
        {{$t('confirm')}}
      </b-button>
      <b-button class="ml-2" variant="danger" @click="closeModal('add-certification-modal')">
        {{$t('close')}}
      </b-button>
    </template>
  </b-modal>
  <NxSigningP12Modal 
  :files="[{name: dummyFile.name,id: signFileId}]" 
  :guid="guid"
  :isRegistration="true" 
  @signComplete="signComplete()" 
  v-model="showSignModal" />
  </div>
</template>

<script>
import { EshApi} from "@/api";
import { FileApi } from 'nx-libs/api';
import NxSigningP12Modal from '@/components/nx-signing-modal/NxSigningP12Modal.vue';
export default {

  components: {
    NxSigningP12Modal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: "",
    guid:"",
    isForProfessional:false,
    isForReset:false,
    hkidForProfessional:null,
  },
  data() {
    return { 
      view: 1,
      file:null,
      hkid:null,
      publicKey:null,
      privateKey:null,
      dummyFolderId:0,
      dummyFile:{},
      showSignModal:false,
      signFileId:0,
      cert:{},
      invitationKey:null
    };
  },
  watch:{
    file(file) {
      if (!file) {
        return;
      }
      if (!(file.name.indexOf(".cer") > -1 || file.name.indexOf(".crt") > -1)) {
        alert('The file format is not support.');
          this.file = null;
          return;
      }
     this.file=file;
    
    },
    async value(value)
    {

    }
  },
  async created() {
    if(this.isForReset){
      this.invitationKey = this.$route.query.key
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
   
    closeModal(modalName) {
      this.hkid = null;
      this.$bvModal.hide(modalName);
    },
    async uploadCert()
    {
  
      try{
        await this.getDummyFile();
        
        const { data: cert }  = (this.isForProfessional||this.isForReset)?await EshApi.uploadCertWithoutDuplicationChecking(this.file):await EshApi.uploadCert(this.file) ;
        
        //remark by Simon, have bug
        // var data = {
        //   CheckCertType : this.isForProfessional,
        //   Hkid : this.hkidForProfessional,
        //   CheckName : this.isForReset,
        //   InvitationKey : this.invitationKey

        // }
        // console.log("data" ,data)
        // const {data : cert } = await EshApi.uploadWithConditional(this.file,  data);
        this.cert = cert;
        console.log("this.cert" , this.cert)
        if(this.isForProfessional)
        {
          var data ={
            MemberCertificationID:cert.id,
            HKID:this.hkidForProfessional,
            GUID:this.guid,
            CheckCertType:true
          };
          await EshApi.uploadCertHKIDWithoutName(data);
        
        }
        else if(this.isForReset)
        {
          var data ={
            MemberCertificationID:cert.id,
            HKID:this.hkid,
            GUID:this.guid
          };
          await EshApi.uploadCertHKIDWithoutName(data);
        }
        else
        {
          var data ={
            MemberCertificationID:cert.id,
            HKID:this.hkid,
            Name:this.name,
            GUID:this.guid
          };
          await EshApi.uploadCertHKID(data);

        }
         this.showSignModal=true;
      }
      catch ({ response }) {
        if (response) {
          var message = response.data; 
          this.$dangerToast("Add certification error", message);
        }
      } 
      
    },
    async getDummyFile(url) {
      var url = $("#dummyFileURL").find("img").attr("src");

      fetch(url)
        .then(res => res.blob()) // Gets the response and returns it as a blob
        .then(blob => {
          var dummyFile = new File([blob], "dummy"+(new Date().getTime())+".png",{type: blob.type});
          this.dummyFile = dummyFile;
        });
    },
    async signComplete()
    {
        this.$emit("addComplete");
    }
    


  }
};
</script>

<style lang="scss" scoped>
.modal-header {
  background-color: #005d99;
}
</style>

<i18n src="@/locales/pages/manage-cert/components/AddCertModal.json"></i18n>